/* eslint camelcase: 0 */
import { getTransformObject } from '~/common/photos/transforms'
import { CampsitesPhotoGallery, PhotoTransforms } from './types'

export class AjaxCampsitePhotosRepository {
  getAjaxUrl(lang: string, campsiteIds: string[]) {
    const params = new URLSearchParams([
      ['campsite_ids', campsiteIds.join(',')],
      ['transformations', 'master_image'],
    ])
    const langPrefix = lang !== 'en-gb' ? `/${lang}` : ''
    return `/_/fallback${langPrefix}/pitchupphotos/campsite-gallery-photos/?${params.toString()}`
  }

  mapResults(response: AjaxResponse): CampsitesPhotoGallery {
    return Object.entries(response).reduce(
      (gallery, [campsiteId, campsitePhotos]) => {
        gallery[campsiteId] = {
          general: campsitePhotos.general.map(mapCampsitePhoto),
          pitchtypes: mapCampsitePitchtypePhotos(campsitePhotos.pitchtypes),
          visitor: campsitePhotos.visitor?.map(mapCampsitePhoto) || [],
        }
        return gallery
      },
      {} as CampsitesPhotoGallery,
    )
  }
}

function mapCampsitePitchtypePhotos(pitchtypes) {
  const mappedEntries = Object.entries(pitchtypes).map(
    ([pitchtypeId, photos]) => {
      return [pitchtypeId, photos.map(mapCampsitePhoto)]
    },
  )
  return Object.fromEntries(mappedEntries)
}

function mapCampsitePhoto({
  caption,
  url,
  tags,
  title_by,
  title_attribution,
  title_attribution_is_visitor,
  photo_id,
}: RawPhotoSnakeCase): CamelCasePhoto {
  return Object.freeze({
    url: getTransformObject<PhotoTransforms>('gallery', url.master_image),
    caption: title_by || caption || '',
    titleAttribution: title_attribution || '',
    titleAttributionIsVisitor: title_attribution_is_visitor,
    tags,
    photoId: photo_id,
  })
}

interface ResponsePitchupPhoto {
  caption: string
  url: { master_image: string }
  title_by: string
}
interface ResponsePhotoGallery {
  general: ResponsePitchupPhoto[]
  visitor?: ResponsePitchupPhoto[]
  pitchtypes?: Record<string, ResponsePitchupPhoto[]>
}

export type AjaxResponse = Record<string, ResponsePhotoGallery>

interface RawPhotoSnakeCase {
  url: { master_image: string }
  title_by: string
  caption?: string | null
  tags: {
    id: number
    name: string
    group: [
      {
        id: number
        name: string
      },
    ]
  }
  title_attribution?: string
  title_attribution_is_visitor: boolean
  photo_id: string
}

interface CamelCasePhoto {
  url: PhotoTransforms
  caption: string
  tags: {
    id: number
    name: string
    group: [
      {
        id: number
        name: string
      },
    ]
  }
  titleAttribution: string
  titleAttributionIsVisitor: boolean
  photoId: string
}
